<template>
  <div>

        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('sellingCostDetail.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="queryConditions" class="flex justify-start">
              <el-form-item>
                <el-date-picker
                  v-model="queryConditions.beginTime"
                  type="date"
                  placeholder="开始时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="queryConditions.endTime"
                  type="date"
                  placeholder="结束时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="queryConditions.prodNameLike"
                  placeholder="商品名称"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleQuery">
                  {{ $t('common.query') }}
                </el-button>
                <el-button icon="el-icon-refresh" @click="handleReset">
                  {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('sellingCostDetail.sellingCostDetail') }}</div>
          </div>
          <selling-cost-detail-table
            :table-data="tableData"
            :sum-total="sumTotal"
            :loading="loading"
            @refresh="fetchData"
          />
          <el-pagination
            :current-page="pagination.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>

  </div>
</template>

<script>
import SellingCostDetailTable from '@/components/goods/SellingCostDetailTable'
import { getSellingCostDetailList } from '@/api/goods/sellingCostDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SellingCostDetailManage',
  components: { SellingCostDetailTable },
  data() {
    return {
      loading: false,
      tableData: [],
      sumTotal: {},
      queryConditions: {
        beginTime: '',
        endTime: '',
        prodNameLike: '',
        shopId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.queryConditions.shopId = getShopId()
    this.fetchData()
  },
  methods: {
    buildQueryParams() {
      const params = {
        ...this.queryConditions,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      if (params.beginTime && params.beginTime.length === 10) {
        params.beginTime = `${params.beginTime} 00:00:00`
      }
      if (params.endTime && params.endTime.length === 10) {
        params.endTime = `${params.endTime} 23:59:59`
      }
      return params
    },
    async fetchData() {
      this.loading = true
      try {
        const res = await getSellingCostDetailList(this.buildQueryParams())
        this.tableData = res.data || []
        this.pagination.total = res.total
        this.sumTotal = res.sumTotal || {}
      } catch (error) {
        console.error('获取销售成本明细失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleReset() {
      this.queryConditions = {
        beginTime: '',
        endTime: '',
        prodNameLike: '',
        shopId: getShopId()
      }
      this.handleQuery()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
</style>